import { Component, inject } from '@angular/core';
import { NavigationContextService } from '../../core/services/navigation-context.service';

/**
 * Placeholder for routes that are wired up but not built yet (see the build
 * order in PleinProduceContext.md section 64). Lets navigation, the topbar,
 * and secondary nav be fully functional ahead of each page's real content.
 */
@Component({
  selector: 'pp-coming-soon',
  standalone: true,
  templateUrl: './coming-soon.component.html',
})
export class ComingSoonComponent {
  private readonly navContext = inject(NavigationContextService);

  readonly pageLabel = this.navContext.pageLabel;
}
